import styled from 'styled-components';

export const PickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid white;
  background: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.surface.default};
  border-radius: 8px;
  width: 230px;
  font-family: ${(props) => props.theme.typography.fontFamily};
`;

export const PickerItem = styled.span`
  padding: ${(props) => `${props.theme.spacing(1)}px`};
  padding-left: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: calc(100% - 24px);
  font-size: 12px;
`;

export const TitleContainer = styled.div`
  width: calc(100% - 12px);
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 34px;
  border-bottom: 1px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N300
        : props.theme.atlas.semantic.color.outline.fixed};
  padding-left: 12px;
`;

export const Title = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
`;
